import { useEffect, useRef } from 'react'

import { setRef } from '../../../utils/react'
import { InputSelectControlContent } from '../InputSelectControlContent'
import { useSelectContext } from '../Select.hooks'
import { SelectControl } from '../SelectControl'
import { SelectControlContainer } from '../SelectControlContainer'

import { focusInputSelectControlAfterOpen } from './InputSelectControl.utils'

function InputSelectControl({
  Container = SelectControlContainer,
  Content = InputSelectControlContent,
  contentProps,
  inputRef,
  ref,
  refs,
  onClickContainer,
  onFocusAfterOpen = focusInputSelectControlAfterOpen,
  ...restProps
}) {
  const { blocked, disabled, isOpen, value } = useSelectContext()

  const inputSelectRef = useRef(null)

  useEffect(() => {
    if (isOpen) {
      onFocusAfterOpen({ inputSelectRef, refs, value })
    }
  }, [isOpen])

  function handleSetInputRef(node) {
    inputSelectRef.current = node

    setRef(inputRef, node)
  }

  function handleClickContainer() {
    onClickContainer?.({ inputSelectRef, refs, value })
  }

  return (
    <SelectControl
      {...restProps}
      Container={Container}
      Content={Content}
      blocked={blocked}
      contentProps={{
        ...contentProps,
        inputRef: handleSetInputRef,
      }}
      disabled={disabled}
      ref={ref}
      onClickContainer={handleClickContainer}
    />
  )
}

export default InputSelectControl
